module.exports = __webpack_public_path__ + "img/believe.b7e09df1.svg";